import { observer } from "mobx-react";
import './index.css';
import strings from "../../localization";
import CustomSelect from "../CustomSelect";
import { useEffect, useState } from "react";
import { DateRangeMenuItems, IssueSolvedList, StateList } from "../../helpers/statics";
import CustomDateRange from "../CustomDateRange";
import { chevronRightIcon, searchIcon } from "../../assets";
import CallStore from "../../stores/CallStore";
import { TextInput } from "../TextInput";
import MainStore from "../../stores/MainStore";
import { isSameDay } from "../../helpers/functions";

const SessionLogsFilter = ({ getCalls, pagination }) => {
  const stateList = StateList.map(item => ({
    key: item.key,
    name: item.title
  }));

  stateList.unshift({
    key: 'all',
    name: 'All'
  });

  const resultList = IssueSolvedList.map(item => ({
    key: item.key,
    name: item.title
  }));

  resultList.unshift({
    key: 'all',
    name: 'All'
  });


  const [state, setStatus] = useState(stateList[0].key);
  const [result, setResult] = useState(resultList[0].key);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [dateRangeOpen, setDateRangeOpen] = useState(false);
  const [search, setSearch] = useState('');

  useEffect(() => {
    const queries = CallStore.filters
    setSearch(queries.q || '');
    setStatus(queries.state || stateList[0].key);
    setResult(queries.result || resultList[0].key);
    setStartDate(queries.startDate ? new Date(queries.startDate) : null);
    setEndDate(queries.endDate ? new Date(queries.endDate) : null);
  }, [CallStore.filters]);

  const handleStatusChange = (value) => {
    setStatus(value);
    if (value === 'all') {
      CallStore.removeFilter('state');
    } else {
      CallStore.setFilters({ state: value });
    }
    getCalls();
  }

  const handleResultChange = (value) => {
    setResult(value);
    if (value === 'all') {
      CallStore.removeFilter('result');
    } else {
      CallStore.setFilters({ result: value });
    }
    getCalls();
  }

  const handleDateRangeChange = () => {
    setDateRangeOpen(false);
    const payload = {
      page: pagination.page,
      limit: pagination.limit,
    }
    if (startDate) {
      payload.startDate = startDate.getTime();
    }
    if (endDate) {

      payload.endDate = new Date(endDate.setHours(23, 59, 59, 999)).getTime();

      payload.endDate = endDate.getTime();
    }
    CallStore.setFilters(payload);
    const resp = getCalls();
  }

  const handleSearch = (value) => {
    setSearch(value);
    if (value.length === 0) {
      CallStore.removeFilter('q');
    } else {
      CallStore.setFilters({ q: value });
    }
    getCalls();
  }

  const getSelectedDateRange = () => {
    const dateRangeItem = DateRangeMenuItems.find(item => isSameDay(item.startDate, startDate) && isSameDay(item.endDate, endDate));


    if (dateRangeItem) {
      return dateRangeItem;
    }
    return DateRangeMenuItems.find(item => item.key === 'custom');
  }

  return (
    <div className="session-logs-filter-container">
      <div className="session-logs-filter-group">
        <span className="session-logs-filter-group-label">{strings.search}</span>
        <div className="session-logs-filter-group-input">
          <TextInput label={null} placeholder={strings.search} value={search} onChange={(e) => handleSearch(e.target.value)} rightIcon={searchIcon} />
        </div>
      </div>

      <div className="session-logs-filter-group">
        <span className="session-logs-filter-group-label">{strings.state}</span>
        <div className="session-logs-filter-group-input">
          <CustomSelect
            icon={null}
            list={stateList}
            value={state}
            setValue={handleStatusChange}
          />
        </div>
      </div>
      <div className="session-logs-filter-group">
        <span className="session-logs-filter-group-label">{strings.result}</span>
        <div className="session-logs-filter-group-input">
          <CustomSelect
            icon={null}
            list={resultList}
            value={result}
            setValue={handleResultChange}
          />
        </div>
      </div>
      <div className="session-logs-filter-group">
        <span>{strings.dateRange}</span>
        <div className="session-logs-filter-group-input">
          <div className="custom-select" onClick={() => setDateRangeOpen(!dateRangeOpen)}>
            <div className="custom-select-content">
              <div className="custom-select-content-right">
                <span className="custom-select-selected-value">{getSelectedDateRange().label}</span>
                <img src={chevronRightIcon} alt="chevron-right" />
              </div>
            </div>
          </div>
          {dateRangeOpen &&
            <CustomDateRange
              getSelectedDateRange={getSelectedDateRange}
              setStartDate={setStartDate}
              setEndDate={setEndDate}
              startDate={startDate}
              endDate={endDate}
              setDateRangeOpen={setDateRangeOpen}
              getCalls={handleDateRangeChange}
            />}
        </div>
      </div>
    </div>
  );
};

export default observer(SessionLogsFilter);